import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import NavBar from "../../../NavBar";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { set } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
const UpdateStaticPage=()=>{
    const {state}=useLocation();
    const [name , setName]=useState(state.item.name);
    const [description , setDescription]=useState(state.item.description);
    const [status , setStatus]=useState(state.item.status);
    const [id , setId]=useState(state.item._id);
    const navigate=useNavigate();
    // const BASE_URL = process.env.REACT_APP_BASE_URL;

    const BASE_URL=process.env.REACT_APP_BASE_URL;
    const token=localStorage.getItem("token");
    const updatepage=()=>{
        const obj={
            name:name,
            description:description,
            status:status
        }

        axios
        .put(`${BASE_URL}admin/updateStaticPage/${id}`,obj,{
            headers:{
                "Content-Type":"Application/json",
                "version":"1.0.0",
                "x-access-token":`${token}`

,
            }
        }).then((response)=>{
            if(response.data.success===false)
            {
                toast.error(response.data.message);
                if(response.data.error_code==461)
                {
                    navigate("/SignIn");
                }
            }else{
                toast.success(response.data.message);
                navigate('/staticpageList');
            }
        }).catch((error)=>{
            console.log(error);
        })
    }
    useEffect(()=>{
console.log("data",description);
    },[])

    return(
        <>

<NavBar/>
        <div className='container ' >
    <div className='row d-flex justify-content-center align-items-center mt-5 '>
        <div className='col-md-8 p-3 p-md-5 adddiv' style={{boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px"}} >
            <h2>Update Static page</h2>
      <div className="row">
      <div className="col-12">
<label className="formleb">Name</label>
<input type="text" className="form-control forminp"
placeholder="Name"
name="name"
value={name}
onChange={(e)=>setName(e.target.value)}
disabled
/>

        </div>
        <div className="col-12">
        <label className="formleb">description</label>

        <CKEditor
        className="forminp"
                    editor={ ClassicEditor }
                    data={description}
                    onReady={ editor => {
                        // You can store the "editor" and use when it is needed.
                        console.log( 'Editor is ready to use!', editor );
                    } }
                    onChange={ ( event, editor ) => {
                        const data = editor.getData();
                        setDescription(data);
                        // console.log( data  );
                    } }
                    onBlur={ ( event, editor ) => {
                        console.log( 'Blur.', editor );
                    } }
                    onFocus={ ( event, editor ) => {
                        console.log( 'Focus.', editor );
                    } }
                />
{/* <input type="text" id="editor"  className="form-control"
name="description"
value={description}
onChange={(e)=>setDescription(e.target.value)}
/> */}

        </div>
        <div className="col-12">
        <label className="formleb">Status</label>
<select name="status" className="form-control forminp" value={status} onChange={(e)=>setStatus(e.target.value)}>
    <option  value="select">--select--</option>
    <option value="Active">Active</option>
    <option value="Inactive">Inactive</option>

</select>
        </div>

        <div className="col-md-6">
        <button type="button" className="formbtn btn  btn-primary mt-3 "  onClick={()=>updatepage()}>Save</button>

        </div>
      </div>

        </div>
    </div>


</div>
        </>
    );
}
export default UpdateStaticPage;